import type { SearchLocation } from '@/scopes/search/search/infrastructure/api/types'
import { tk, Typography } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'
import { Card } from '../../../../../../../common/components/Card'
import { ImageCarousel } from '../ProductCard/ImageCarousel'
import { LocationTag } from '../ProductCard/LocationTag'
import { OverlayLink } from '../ProductCard/OverlayLink'
import { ScoreRatings } from '../ProductCard/ScoresRatings'

export interface ProductCardCompactProps {
  id: number
  accommodationId: number
  href?: string
  imageSources: string[]
  locations?: SearchLocation[]
  name?: string
  userRating?: number
  userRatingText: string
  rating: number
}

const StyledProductCardCompactWrapper = styled(Card)`
  position: relative;
`

const ImageWrapper = styled.div`
  height: 216px;

  @media (hover: hover) {
    &:hover {
      button {
        display: inline-flex;
      }
    }
  }
`

const StyledLocationTag = styled(LocationTag)`
  margin-top: ${tk('spacing_xs')};
`

const StyledContentWrapper = styled.div`
  padding: ${tk('spacing_md')};
`

export function ProductCardCompact({
  id,
  href,
  imageSources,
  locations,
  name = '',
  userRating,
  userRatingText,
  rating,
}: ProductCardCompactProps) {
  return (
    <StyledProductCardCompactWrapper>
      {href && <OverlayLink href={href} aria-label={name} target="_blank" />}
      {' '}
      <ImageWrapper>
        <ImageCarousel imageIndex={id} images={imageSources.map(imageSrc => ({ src: imageSrc, alt: name }))} />
      </ImageWrapper>
      <StyledContentWrapper>
        {userRating !== undefined && userRating > 0 && (
          <ScoreRatings rating={rating} userRating={userRating} aria-label={userRatingText} />
        )}
        <Typography $variant="heading-md" as="span">
          {name}
        </Typography>
        {locations && <StyledLocationTag locations={locations} />}
      </StyledContentWrapper>
    </StyledProductCardCompactWrapper>
  )
}

ProductCardCompact.displayName = 'ProductCardCompact'
